import { render, staticRenderFns } from "./ParticipantCollective.vue?vue&type=template&id=73bbcc48"
import script from "./ParticipantCollective.vue?vue&type=script&lang=js"
export * from "./ParticipantCollective.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports